import instance from '../utils/axios';

export const getAllOpenBets = async () => {
    const response = await instance.get('/api/betting/open-bets');
    return response.data;
};

export const getOpenBetById = async (eventId) => {
    const response = await instance.get(`/api/betting/open-bets/${eventId}`);
    return response.data;
};
